module.exports = __webpack_public_path__ + "static/media/bottom_bg.a44c7a22.svg";